import React from 'react';
import PropTypes from 'prop-types';
import YouTube from '../YouTube';
import { prismicImage } from 'src/common/utils/prismic-image';

const Slide = props => (
  <div
    className={`product-hero-${props.type.toLowerCase()}-slide`}
    style={props.style}>
    {props.type === 'Video' && (
      <YouTube
        setIsCarouselMediaPlaying={props.setIsCarouselMediaPlaying}
        videoId={props.videoId}
        imagePath={props.image.url}
      />
    )}
    {props.type === 'Image' && (
      <img
        src={prismicImage(props.image, { width: 920 })}
        alt={props.image.alt || ''}
      />
    )}
  </div>
);

Slide.propTypes = {
  type: PropTypes.string.isRequired,
  style: PropTypes.object,
  videoId: PropTypes.string,
  image: PropTypes.object.isRequired,
  setIsCarouselMediaPlaying: PropTypes.func.isRequired,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductHero/Slide.js